import { getLangCode } from "@/app/(site)/_utils/misc"
import { useAppSelector } from "@/app/(site)/contexts/Global"
import { t } from "@/translations"
import { usePathname } from "next/navigation"
import Text from "../../../Atoms/Text"

interface SelectedSizeProps {
    initialSelectedSize: string | undefined
    isOneSizeSSR?: boolean
}

export default function SelectedSize({
    initialSelectedSize,
    isOneSizeSSR
}: SelectedSizeProps) {
    const availableSizesContext = useAppSelector(state => state.product.availableSizes)
    const initialValueSize = useAppSelector(state => state.product.selectedSize)
    const langCode = getLangCode(usePathname().split("/")[1]) || ""

    const isAvailableButNotSelected = availableSizesContext.some(
        (size: { isAvailable: boolean; isSelected: boolean }) =>
            size.isAvailable && !size.isSelected
    )
    const isAnySizeSelected = availableSizesContext.some(
        (size: { isSelected: boolean }) => size.isSelected
    )
    const isSelectedSizeAvailable = availableSizesContext.some(
        (size: { isSelected: boolean; isAvailable: boolean }) =>
            size.isSelected && size.isAvailable
    )

    const isOneSizeClient =
        availableSizesContext.length === 1 &&
        availableSizesContext[0]?.name === "One Size"

    return (
        <Text size="small" weight="regular">
            {t(langCode, "product_page.size")}:{" "}
            {isOneSizeSSR ? (
                t(langCode, "product_page.one_size")
            ) : (
                <>
                    {isOneSizeClient && isSelectedSizeAvailable && "One Size"}
                    {isAvailableButNotSelected && !isAnySizeSelected
                        ? t(langCode, "product_page.select_size")
                        : isSelectedSizeAvailable
                          ? initialValueSize
                          : initialSelectedSize}
                </>
            )}
        </Text>
    )
}
